//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.DialogsAdeInstitucionalniPredpoklad.ts						</Name>
//    <Description> Funkce pro otev�en� dialog� spojen�ch s Typ institucion�ln�ho p�edpokladu </Description>
//    <Author>      JKLUSACEK													</Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-10-21                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=486.16.5
//AdtGeneratorConfig:[ T:(srvstip) GID:(Web.Dia.Ts) V1:(ixs_tip,nazev,aktivita,ixs_typ,dat_zmena,zmenu_prov,k_v,rezim_real,priz_nevyzad) V2:() K1:() K2:() K3:() ]

namespace Gordic.Adm.Dialogs {

    // AdeInstitucionalniPredpoklad
    export function DetailAdeInstitucionalniPredpokladDlg(
        parentContent: GContent,
        opt: {
            /** ixs_tip */
            ixs_tip: string | null,
            /** grid jquery element */
            grid?: JQuery<HTMLElement>,
            /** p��znak nov�ho z�znamu */
            newRecord?: boolean
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

    const deferred = $.Deferred();
    const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
    ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

    let isValid = true;
    var detailCommand = opt.grid ? false : true;

    // grid remote control, kv�li �ipk�m na detailu
    const gridRemoteControl = opt && opt.grid ? new Gordic.Components.GridRC(opt.grid) : undefined;

    var detail = ['Gordic.Adm.WebControls.DetailAdeInstitucionalniPredpoklad', { gridRemoteControl: gridRemoteControl }]

    const options = {
        ID: "AdmAdeInstitucionalniPredpoklad#",
        ixs_tip: opt ? opt.ixs_tip : undefined,
        newRecord: opt ? opt.newRecord : undefined,
        detailCommand: detailCommand
    };

    if (isValid) {
        //RC 32131033 : Detail
        Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
    } else {
        deferred.reject();
    }
    return deferred.promise();
}

    // AdeInstitucionalniPredpoklad
    export function SeznamAdeInstitucionalniPredpokladDlg(
        parentContent: GContent,
        opt: {
            /** ixs_tip */
            ixs_tip: string | null,
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

    const deferred = $.Deferred();
    const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
    ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

    let isValid = true;

    var detail = ['Gordic.Adm.WebControls.SeznamAdeInstitucionalniPredpoklad', { }]

    const options = {
        ID: "AdmAdeInstitucionalniPredpoklad#",
        ixs_tip: opt ? opt.ixs_tip : undefined,
    };

    if (isValid) {
        //RC 32131033 : Detail
        Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
    } else {
        deferred.reject();
    }
    return deferred.promise();
  }

}
